export interface FullDateTimeFormatOptions {
	localeMatcher?: 'best fit' | 'lookup';
	weekday?: 'narrow' | 'short' | 'long';
	era?: 'narrow' | 'short' | 'long';
	year?: 'numeric' | '2-digit';
	month?: 'numeric' | '2-digit' | 'narrow' | 'short' | 'long';
	day?: 'numeric' | '2-digit';
	hour?: 'numeric' | '2-digit';
	minute?: 'numeric' | '2-digit';
	second?: 'numeric' | '2-digit';
	fractionalSecondDigits?: 1 | 2 | 3;
	timeZoneName?: | 'short' | 'long' | 'shortOffset' | 'longOffset' | 'shortGeneric' | 'longGeneric';
	formatMatcher?: 'best fit' | 'basic';
	hour12?: boolean;
	hourCycle?: 'h11' | 'h12' | 'h23' | 'h24';
	timeZone?: StandardFourTimeZoneId;
	dateStyle?: 'full' | 'long' | 'medium' | 'short';
	timeStyle?: 'full' | 'long' | 'medium' | 'short';
	calendar?: string;
	numberingSystem?: string;
	dayPeriod?: 'narrow' | 'short' | 'long';
}

export const TIME_OPTIONS: FullDateTimeFormatOptions = { hour: "numeric", minute: "2-digit", hour12: true, timeZoneName: "short" };

export const DATE_OPTIONS_MMDDYYYY: FullDateTimeFormatOptions = { year: "numeric", month: "2-digit", day: "numeric" };

export const DATE_OPTIONS_MMDD: FullDateTimeFormatOptions = { month: "short", day: "numeric" };

export const DATE_OPTIONS_MMMDD: FullDateTimeFormatOptions = { month: "long", day: "numeric" };

export const DATE_OPTIONS_DDMMMMMYYYY: FullDateTimeFormatOptions = { day: "numeric", month: "long", year: "numeric", };

export const DATE_OPTIONS_MMMDYYYY: FullDateTimeFormatOptions = { year: "numeric", month: 'short', day: "numeric" };

export type StandardFourTimeZoneId = 1 | 3 | 5 | 7; // 1-Eastern, 3-Pacific, 5-Central, 7-Mountain

export type WeekdayIndex = 0 | 1 | 2 | 3 | 4 | 5 | 6; //0=Mon, 1=Tue, 2=Wed, 3=Thu, 4=Fri, 5=Sat, 6=Sun

export type DateFormat = 'MM/DD/YYYY' | 'MMM D, YYYY' | 'MMM D, YYYY (DOW)' | 'DOW MMM D, YYYY' | 'MMM D' | 'MMM, DD YYYY' | 'MMM/DD DOW' | 'MMMM, DD YYYY' | 'MM D (DOW)';